import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Card, Spinner, EmptyState } from "@/components/bits";
import { Bell, CheckCircle2, AlertTriangle } from "lucide-react";

export default function Notifications() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/notifications").then((r) => setRows(r.data)).finally(() => setLoading(false)); }, []);

  return (
    <div>
      <PageHeader title="Notifikasi" subtitle="Update kelengkapan part & alert." />
      {loading ? <Spinner /> : rows.length === 0 ? <EmptyState title="Belum ada notifikasi" icon={Bell} /> : (
        <div className="grid gap-2">
          {rows.map((n) => {
            const complete = n.kind === "PART_COMPLETE";
            return (
              <Card key={n.id} className={`p-4 flex items-start gap-3 ${complete ? "border-emerald-200 bg-emerald-50" : "border-amber-200 bg-amber-50"}`} data-testid={`notif-${n.id}`}>
                {complete ? <CheckCircle2 size={20} className="text-emerald-600 mt-0.5 shrink-0" /> : <AlertTriangle size={20} className="text-amber-600 mt-0.5 shrink-0" />}
                <div>
                  <div className="font-head font-semibold text-gray-900">{n.title}</div>
                  <div className="text-sm text-gray-700 whitespace-pre-line mt-0.5">{n.message}</div>
                  <div className="text-xs text-gray-400 mt-1">{new Date(n.created_at).toLocaleString("id-ID")}</div>
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
